import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table'
import { convertToDate, convertToHHMM } from '../../../lib/date'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux'
import { useQuery } from '@tanstack/react-query'
import axios from '../../../lib/axios'
import useAuth from '../../../hooks/useAuth'

type ScansProps = {
    scans: Scan[]
}

const Scans : React.FC<ScansProps> = ({scans}) => {
  const { auth } = useAuth();
  
  const { data:params=[] } = useQuery({
    queryKey: ['param-functions'],
    queryFn: async () => {
      const { data } = await axios.post(`param/function`, {
        token: auth.data?.token
      })
      return data?.object?.function || []
    }
  })
  
  const {t} = useTranslation()
  return (
    <Table>
      <TableHeader className='bg-slate-100'>
        <TableRow>
          <TableHead>{t("components.o_scans.date")}</TableHead>
          <TableHead>{t("components.o_scans.time")}</TableHead>
          <TableHead>{t("components.o_scans.barcode")}</TableHead>
          <TableHead>{t("components.o_scans.vault")}</TableHead>
          <TableHead>{t("components.o_scans.remark")}</TableHead>
          <TableHead>{t("components.o_scans.execution")}</TableHead>
          <TableHead>IDPDA</TableHead>
          <TableHead>{t("components.o_scans.key")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {scans && scans.map((h, i) => {
          const currentFunction = params?.find((p:any) => p?.code === h?.function) || { description:h?.function }
          
          return (
            <TableRow key={i}>
              <TableCell className='whitespace-nowrap'>{format(convertToDate(h.dtcreation) || new Date(), "dd/MM/yyyy")}</TableCell>
              <TableCell>{convertToHHMM(h.tmcreation)}</TableCell>
              <TableCell>{h.barcode}</TableCell>
              <TableCell>{h.vault}</TableCell>
              <TableCell>{h.remark}</TableCell>
              <TableCell>{currentFunction?.description}</TableCell>
              <TableCell>{h.idpda}</TableCell>
              <TableCell>{h.sleutel ? t("components.o_scans.yes") : t("components.o_scans.no")}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export default Scans